import { render, staticRenderFns } from "./BookUploadModal.vue?vue&type=template&id=4b435254"
import script from "./BookUploadModal.vue?vue&type=script&lang=ts"
export * from "./BookUploadModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports